const zh_CN = {
  refresh_tip: '刷新间隔小于 step({{num}}s) 将不会更新数据',
};
export default zh_CN;
